import type { GiftPassBundle } from '@bonsai/shared';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { formatAbsoluteDate } from '../../../utils/relative-age';
import { bundleDiscountLabel, passCountLabel } from '../gift-pass-bundles-list-model';
import { giftPassBundlePath } from '../gift-pass-bundles-paths';
import { GiftPassTagList } from '../tags/GiftPassTagList';

import { GiftPassBundlePromotedBadge } from './GiftPassBundlePromotedBadge';
import { GiftPassBundleStatusPill } from './GiftPassBundleStatusPill';

import '../../shared/list-page/list-page.css';
import './gift-pass-bundles-list.css';

export interface GiftPassBundlesTableRowProps {
  bundle: GiftPassBundle;
  canOpen: boolean;
}

export function GiftPassBundlesTableRow({ bundle, canOpen }: GiftPassBundlesTableRowProps) {
  return (
    <tr
      className={bundle.isActive ? undefined : 'gpb-inactive'}
      style={{ position: 'relative', cursor: canOpen ? 'pointer' : undefined }}
    >
      <td style={{ paddingLeft: 18 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          {canOpen ? (
            <Link to={giftPassBundlePath(bundle.id)} className="gpb-name nb-listpage-row-link">
              {bundle.name}
            </Link>
          ) : (
            <span className="gpb-name">{bundle.name}</span>
          )}
          {bundle.isPromoted && <GiftPassBundlePromotedBadge />}
        </div>
      </td>
      <td className="nb-tabular">{passCountLabel(bundle.passCount)}</td>
      <td>
        <span className="nb-tabular gpb-discount-chip">{bundleDiscountLabel(bundle)}</span>
      </td>
      <td>
        <GiftPassTagList tags={bundle.tags} />
      </td>
      <td>
        <GiftPassBundleStatusPill isActive={bundle.isActive} />
      </td>
      <td className="nb-tabular" style={{ paddingRight: 18, color: 'var(--nb-muted)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ flex: 1, whiteSpace: 'nowrap' }}>
            {formatAbsoluteDate(bundle.updatedAt)}
          </span>
          {canOpen && <ChevronRight size={14} aria-hidden style={{ color: 'var(--nb-faint)' }} />}
        </div>
      </td>
    </tr>
  );
}
